export const UserEndpoint = {
  LOAD_SETTINGS: '/default/user-profile/load-settings',
  LOAD_CONTACT_DETAILS: '/default/user-profile/load-contact-details',
  LOAD_CURRENT_USER: '/default/user-profile/load-current-user',
  CHANGE_PASSWORD: '/default/user-profile/change-password',
  SAVE_SETTINGS: '/default/user-profile/save-settings',
  SAVE_CONTACT_DETAILS: '/default/user-profile/save-contact-details',
  CHECK_EXISTING_USERNAMES: '/default/user-profile/check-username',
  IS_USER_PARTNER_ADMIN: '/default/user-profile/is-user-partner-admin',
};
